import { OptionType } from './project';

export const statusOptions: OptionType[] = [
    { label: 'Verified', id: '1' },
    { label: 'Declined', id: '2' },
    { label: 'Pending', id: '3' }
];
